import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

// ============================================
// UserPointHistory — 상단 보유 포인트 카드 + 요약 카드 레이아웃
// ============================================
export const TopRow = styled(Box)({
  display: 'flex',
  gap: '16px',
  marginBottom: '24px',
  alignItems: 'stretch',
});

export const BalanceCard = styled(Box)({
  flex: '0 0 400px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '10px',
  padding: '18px 24px',
  background: '#fff',
  border: '1px solid #E5E9EC',
  borderRadius: '12px',
});

export const BalanceHeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const BalanceLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#3D3D3D',
});

export const BalanceValue = styled(Typography)({
  fontSize: '28px',
  fontWeight: 700,
  color: '#111111',
});

// 보유 포인트 아래 다음 소멸 예정 안내
export const ExpiringText = styled(Typography)({
  fontSize: '12px',
  fontWeight: 600,
  color: '#F1685A',
});

export const ChangeButton = styled(Button)({
  minWidth: '64px',
  height: '32px',
  padding: '0 14px',
  borderRadius: '6px',
  fontSize: '13px',
  fontWeight: 600,
  boxShadow: 'none',
  backgroundColor: '#262626',
  color: '#fff',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: '#262626',
  },
});

export const SummaryCardsWrapper = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
});

// ============================================
// PointChangeModal — 적립/차감 폼
// ============================================
export const SegmentWrapper = styled(Box)({
  marginBottom: '20px',
});

export const FieldsBox = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
  padding: '20px',
  borderRadius: '10px',
  border: '1px solid #E5E7EB',
  backgroundColor: '#FAFAFA',
  marginBottom: '16px',
});

export const FieldGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
});

export const FieldLabel = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  color: '#3D3D3D',
});

export const PreviewBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  padding: '14px',
  borderRadius: '8px',
  border: '1px solid #BFE3E5',
  backgroundColor: '#F3FAFB',
  fontSize: '15px',
  fontWeight: 600,
  color: '#3D3D3D',
  marginBottom: '20px',
});

export const PreviewHighlight = styled('span', {
  shouldForwardProp: prop => prop !== 'isOverdraft',
})(({ isOverdraft }) => ({
  color: isOverdraft ? '#dc2626' : '#0F7F85',
  fontWeight: 700,
}));

export const MemoWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
});

export const PointSuffix = styled('span')({
  marginLeft: '4px',
  color: '#8c8c8c',
  fontSize: '14px',
});
